import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MsfSelect } from '@components/select/select';

/**
 * Process picker shared by assignment, subscription, trigger, and notification forms.
 * The closed filter on the assignments list hides the key; dialogs keep it visible.
 */
@Component({
  selector: 'app-orchestration-process-select',
  standalone: true,
  imports: [MsfSelect],
  templateUrl: './orchestration-process-select.html',
  styleUrl: './orchestration-process-select.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationProcessSelectComponent {
  readonly model = model('');
  readonly options = input<any[]>([]);
  readonly optionValue = input('id');
  readonly placeholder = input('Process');
  readonly showClear = input(false);
  readonly disabled = input(false);
  readonly width = input('100%');
  readonly showSelectedSubtitle = input(true);

  onModelChange(value: string | null): void {
    this.model.set(value ?? '');
  }
}
